import { render, staticRenderFns } from "./BonusForecast.vue?vue&type=template&id=5e9f45d6&scoped=true&"
import script from "./BonusForecast.vue?vue&type=script&lang=js&"
export * from "./BonusForecast.vue?vue&type=script&lang=js&"
import style0 from "./BonusForecast.vue?vue&type=style&index=0&id=5e9f45d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9f45d6",
  null
  
)

export default component.exports